module.exports = __webpack_public_path__ + "static/ac-4-8552c0380ae4d6560154e7c19dbb1beb.jpg";